module.exports = __webpack_public_path__ + "static/img/WechatIMG7009.e5cfa7b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/markdown/WechatIMG7009.jpeg
// module id = z70Z
// module chunks = 0